import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import TuneIcon from "@mui/icons-material/Tune";
import {
  Badge,
  Button,
  IconButton,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import { Stack } from "@mui/system";

const Puller = styled("div")(({ theme }) => ({
  width: spacing.Spacing["4xl"].$value,
  height: spacing.Spacing.xs.$value,
  backgroundColor: colors.GrayLightMode[300].$value,
  borderRadius: spacing.Radius.xs.$value,
  position: "absolute",
  top: spacing.Spacing.xl.$value,
  left: "calc(50% - 15px)",
  ...theme.applyStyles("dark", {
    backgroundColor: colors.GrayLightMode[300].$value,
  }),
}));

export default function CACActionFilterBy() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const [range, setRange] = React.useState("select_label");
  const [range01, setRange01] = React.useState("select_source");
  const [range02, setRange02] = React.useState("select_country");
  const [range03, setRange03] = React.useState("select_campaign");
  const [range04, setRange04] = React.useState("select_Ad_Group");
  const [range05, setRange05] = React.useState("select_Keyword");

  const ShortList = (
    <Box>
      <Puller />
      <Stack
        justifyContent={"space-between"}
        direction="row"
        mt={1.5}
        mb={1}
        alignItems={"center"}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: typography.Size.Text.xs.$value,
            lineHeight: typography.Line_height.text.xs.$value,
            color: colors.GrayLightMode[700].$value,
          }}
        >
          Filter by
        </Typography>
        <Typography
          onClick={toggleDrawer(false)}
          sx={{
            fontSize: typography.Size.Text.xs.$value,
            lineHeight: typography.Line_height.text.xs.$value,
            color: colors.GrayLightMode[700].$value,
            fontWeight: typography.Font_weight.Semibold.$value,
            textTransform: "capitalize",
            letterSpacing: 0,
            p: 0,
          }}
        >
          Clear All
        </Typography>
      </Stack>

      <Box sx={{ my: spacing.Spacing.lg.$value }}>
        <Stack
          alignItems={"center"}
          justifyContent={"space-between"}
          flexDirection={"row"}
        >
          <Typography
            color={colors.GrayLightMode[700].$value}
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              lineHeight: typography.Line_height.text.sm.$value,
            }}
          >
            Note Labels
          </Typography>
          <FormControl size="small">
            <Select
              value={range}
              onChange={(e) => setRange(e.target.value)}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      fontSize: typography.Size.Text.sm.$value,
                      minHeight: spacing.Spacing["5xl"].$value,
                    },
                  },
                },
              }}
              sx={{
                borderRadius: 2,
                height: spacing.Spacing["4xl"].$value,
                minWidth: 184,
                maxWidth: 184,
                py: spacing.Spacing.sm.$value,
                fontSize: typography.Size.Text.sm.$value,
                lineHeight: typography.Line_height.text.sm.$value,
                fontWeight: typography.Font_weight.Semibold.$value,
                color: colors.GrayLightMode[700].$value,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.GrayLightMode[300].$value,
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.Brand[600].$value,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.Brand[600].$value,
                },
                "& .MuiSelect-icon": {
                  color: colors.GrayLightMode[700].$value,
                },
              }}
            >
              <MenuItem value="select_label">Select Label</MenuItem>
              <MenuItem value="item_01">Item 01</MenuItem>
              <MenuItem value="item_02">Item 02</MenuItem>
            </Select>
          </FormControl>
        </Stack>

        <Divider
          sx={{
            my: spacing.Spacing.lg.$value,
            borderWidth: spacing.Spacing.xxs.$value,
            borderColor: colors.GrayLightMode[100].$value,
            borderRadius: spacing.Radius.xxs.$value,
          }}
        />

        <Stack
          alignItems={"center"}
          justifyContent={"space-between"}
          flexDirection={"row"}
        >
          <Typography
            color={colors.GrayLightMode[700].$value}
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              lineHeight: typography.Line_height.text.sm.$value,
            }}
          >
            Traffic Source
          </Typography>
          <FormControl size="small">
            <Select
              disabled
              value={range01}
              onChange={(e) => setRange01(e.target.value)}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      fontSize: typography.Size.Text.sm.$value,
                      minHeight: spacing.Spacing["5xl"].$value,
                    },
                  },
                },
              }}
              sx={{
                borderRadius: 2,
                height: spacing.Spacing["4xl"].$value,
                minWidth: 184,
                maxWidth: 184,
                py: spacing.Spacing.sm.$value,
                fontSize: typography.Size.Text.sm.$value,
                lineHeight: typography.Line_height.text.sm.$value,
                fontWeight: typography.Font_weight.Semibold.$value,
                color: colors.GrayLightMode[700].$value,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.GrayLightMode[300].$value,
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.Brand[600].$value,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.Brand[600].$value,
                },
                "& .MuiSelect-icon": {
                  color: colors.GrayLightMode[700].$value,
                },
                // ✅ disabled style
                "&.Mui-disabled": {
                  background: "#E9EAEB",
                  color: colors.GrayLightMode[500].$value,
                },

                "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.GrayLightMode[300].$value,
                },
              }}
            >
              <MenuItem value="select_source">Select Source</MenuItem>
              <MenuItem value="item_01">Item 01</MenuItem>
              <MenuItem value="item_02">Item 02</MenuItem>
            </Select>
          </FormControl>
        </Stack>

        <Stack
          alignItems={"center"}
          justifyContent={"space-between"}
          flexDirection={"row"}
          sx={{ my: spacing.Spacing.lg.$value }}
        >
          <Typography
            color={colors.GrayLightMode[700].$value}
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              lineHeight: typography.Line_height.text.sm.$value,
            }}
          >
            Country
          </Typography>
          <FormControl size="small">
            <Select
              disabled
              value={range02}
              onChange={(e) => setRange02(e.target.value)}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      fontSize: typography.Size.Text.sm.$value,
                      minHeight: spacing.Spacing["5xl"].$value,
                    },
                  },
                },
              }}
              sx={{
                borderRadius: 2,
                height: spacing.Spacing["4xl"].$value,
                minWidth: 184,
                maxWidth: 184,
                py: spacing.Spacing.sm.$value,
                fontSize: typography.Size.Text.sm.$value,
                lineHeight: typography.Line_height.text.sm.$value,
                fontWeight: typography.Font_weight.Semibold.$value,
                color: colors.GrayLightMode[700].$value,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.GrayLightMode[300].$value,
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.Brand[600].$value,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.Brand[600].$value,
                },
                "& .MuiSelect-icon": {
                  color: colors.GrayLightMode[700].$value,
                },
                // ✅ disabled style
                "&.Mui-disabled": {
                  background: "#E9EAEB",
                  color: colors.GrayLightMode[500].$value,
                },

                "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.GrayLightMode[300].$value,
                },
              }}
            >
              <MenuItem value="select_country">Select Country</MenuItem>
              <MenuItem value="item_01">Item 01</MenuItem>
              <MenuItem value="item_02">Item 02</MenuItem>
            </Select>
          </FormControl>
        </Stack>

        <Stack
          alignItems={"center"}
          justifyContent={"space-between"}
          flexDirection={"row"}
          sx={{ my: spacing.Spacing.lg.$value }}
        >
          <Typography
            color={colors.GrayLightMode[700].$value}
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              lineHeight: typography.Line_height.text.sm.$value,
            }}
          >
            Campaign
          </Typography>
          <FormControl size="small">
            <Select
              disabled
              value={range03}
              onChange={(e) => setRange03(e.target.value)}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      fontSize: typography.Size.Text.sm.$value,
                      minHeight: spacing.Spacing["5xl"].$value,
                    },
                  },
                },
              }}
              sx={{
                borderRadius: 2,
                height: spacing.Spacing["4xl"].$value,
                minWidth: 184,
                maxWidth: 184,
                py: spacing.Spacing.sm.$value,
                fontSize: typography.Size.Text.sm.$value,
                lineHeight: typography.Line_height.text.sm.$value,
                fontWeight: typography.Font_weight.Semibold.$value,
                color: colors.GrayLightMode[700].$value,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.GrayLightMode[300].$value,
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.Brand[600].$value,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.Brand[600].$value,
                },
                "& .MuiSelect-icon": {
                  color: colors.GrayLightMode[700].$value,
                },
                // ✅ disabled style
                "&.Mui-disabled": {
                  background: "#E9EAEB",
                  color: colors.GrayLightMode[500].$value,
                },

                "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.GrayLightMode[300].$value,
                },
              }}
            >
              <MenuItem value="select_campaign">Select Campaign</MenuItem>
              <MenuItem value="item_01">Item 01</MenuItem>
              <MenuItem value="item_02">Item 02</MenuItem>
            </Select>
          </FormControl>
        </Stack>

        <Stack
          alignItems={"center"}
          justifyContent={"space-between"}
          flexDirection={"row"}
          sx={{ my: spacing.Spacing.lg.$value }}
        >
          <Typography
            color={colors.GrayLightMode[700].$value}
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              lineHeight: typography.Line_height.text.sm.$value,
            }}
          >
            Ad Group
          </Typography>
          <FormControl size="small">
            <Select
              disabled
              value={range04}
              onChange={(e) => setRange04(e.target.value)}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      fontSize: typography.Size.Text.sm.$value,
                      minHeight: spacing.Spacing["5xl"].$value,
                    },
                  },
                },
              }}
              sx={{
                borderRadius: 2,
                height: spacing.Spacing["4xl"].$value,
                minWidth: 184,
                maxWidth: 184,
                py: spacing.Spacing.sm.$value,
                fontSize: typography.Size.Text.sm.$value,
                lineHeight: typography.Line_height.text.sm.$value,
                fontWeight: typography.Font_weight.Semibold.$value,
                color: colors.GrayLightMode[700].$value,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.GrayLightMode[300].$value,
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.Brand[600].$value,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.Brand[600].$value,
                },
                "& .MuiSelect-icon": {
                  color: colors.GrayLightMode[700].$value,
                },
                // ✅ disabled style
                "&.Mui-disabled": {
                  background: "#E9EAEB",
                  color: colors.GrayLightMode[500].$value,
                },

                "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.GrayLightMode[300].$value,
                },
              }}
            >
              <MenuItem value="select_Ad_Group">Select Ad Group</MenuItem>
              <MenuItem value="item_01">Item 01</MenuItem>
              <MenuItem value="item_02">Item 02</MenuItem>
            </Select>
          </FormControl>
        </Stack>

        <Stack
          alignItems={"center"}
          justifyContent={"space-between"}
          flexDirection={"row"}
          sx={{ my: spacing.Spacing.lg.$value }}
        >
          <Typography
            color={colors.GrayLightMode[700].$value}
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              lineHeight: typography.Line_height.text.sm.$value,
            }}
          >
            Keyword
          </Typography>
          <FormControl size="small">
            <Select
              disabled
              value={range05}
              onChange={(e) => setRange05(e.target.value)}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      fontSize: typography.Size.Text.sm.$value,
                      minHeight: spacing.Spacing["5xl"].$value,
                    },
                  },
                },
              }}
              sx={{
                borderRadius: 2,
                height: spacing.Spacing["4xl"].$value,
                minWidth: 184,
                maxWidth: 184,
                py: spacing.Spacing.sm.$value,
                fontSize: typography.Size.Text.sm.$value,
                lineHeight: typography.Line_height.text.sm.$value,
                fontWeight: typography.Font_weight.Semibold.$value,
                color: colors.GrayLightMode[700].$value,

                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.GrayLightMode[300].$value,
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.Brand[600].$value,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.Brand[600].$value,
                },
                "& .MuiSelect-icon": {
                  color: colors.GrayLightMode[700].$value,
                },
                // ✅ disabled style
                "&.Mui-disabled": {
                  background: "#E9EAEB",
                  color: colors.GrayLightMode[500].$value,
                },

                "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.GrayLightMode[300].$value,
                },
              }}
            >
              <MenuItem value="select_Keyword">Select Keyword</MenuItem>
              <MenuItem value="item_01">Item 01</MenuItem>
              <MenuItem value="item_02">Item 02</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Box>

      <Button
        fullWidth
        variant="contained"
        sx={{
          textTransform: "capitalize",
          boxShadow: "none !important",
          background: colors.Brand[600].$value,
          borderRadius: 2,
          mt: spacing.Spacing.lg.$value,
        }}
      >
        Apply
      </Button>
    </Box>
  );

  return (
    <>
      <IconButton color="secondary" size="large" onClick={toggleDrawer(true)}>
        <Badge
          color="secondary"
          sx={{
            "& .MuiBadge-badge": {
              height: spacing.Spacing.lg.$value,
              width: spacing.Spacing.lg.$value,
              borderRadius: spacing.Radius.full.$value,
              backgroundColor: colors.Brand[600].$value,
            },
          }}
          variant="dot"
        >
          <TuneIcon sx={{ color: colors.GrayLightMode[700].$value }} />
        </Badge>
      </IconButton>

      <Drawer
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            borderTopLeftRadius: spacing.Radius.xl.$value,
            borderTopRightRadius: spacing.Radius.xl.$value,
            p: spacing.Spacing.xl.$value + "!important",
          },
        }}
      >
        {ShortList}
      </Drawer>
    </>
  );
}
